import { apiRequest } from "@/api/apiRequest";

export const fetchSingleDayPrice = async () =>
  apiRequest({
    method: "GET",
    path: "registration/single-day/price"
  });

export const fetchRooms = async data =>
  apiRequest({
    method: "POST",
    path: "registration/rooms",
    body: data
  });

export const fetchCoupon = async (sessionKey, coupon) =>
  apiRequest({
    method: "PUT",
    path: `registration/${sessionKey}/coupon`,
    body: {
      code: coupon
    }
  });

export const postForm = async (sessionKey, body, lang) =>
  apiRequest({
    method: "POST",
    path: `registration/${sessionKey}/submit?lang=${lang}`,
    body
  });

export const postSingleRegisterForm = async (body, lang) =>
  apiRequest({
    method: "POST",
    path: `registration/single-day?lang=${lang}`,
    body
  });

export const fetchRegistrationStatus = async (sessionId, registrationId) =>
  apiRequest({
    method: "GET",
    path: `registration/${sessionId}/payment-status?registration_id=${registrationId}`
  });

export const fetchPaymentLink = async (paymentId, registrationId) =>
  apiRequest({
    method: "POST",
    path: `registration/${registrationId}/payment/${paymentId}/payment-link`
  });

export const fetchCategories = async () =>
  apiRequest({
    method: "GET",
    path: "registration/categories"
  });
